import React from 'react';
import { TODO_STATUS_COLUMNS } from 'constants/todos';
import { Skeleton } from 'components/layout/loading';
import TodoKanbanColumn from '../TodoKanbanColumn/TodoKanbanColumn';

function TodoKanbanBoardSkeletonColumn({ column }) {
  return (
    <div className="flex min-w-0 flex-col">
      <div className="flex items-center gap-2 rounded-lg bg-gray-800/50 px-3 py-2">
        <span className="text-sm font-semibold text-white">{column.label}</span>
        <Skeleton className="h-5 w-8 rounded-md" />
      </div>

      <div className="mt-2 flex flex-col gap-2 rounded-lg border-2 border-transparent bg-gray-900/30 p-2">
        {[1, 2, 3].map((item) => (
          <div key={`${column.id}-${item}`} className="rounded-lg border border-gray-700 bg-gray-800 p-3">
            <div className="flex items-center justify-between gap-2">
              <div className="flex min-w-0 flex-1 items-center gap-2.5">
                <Skeleton className="h-5 w-14 rounded-md" />
                <Skeleton variant="text" className="h-4 w-full max-w-[10rem]" />
              </div>
              <Skeleton className="h-5 w-5 rounded-md" />
            </div>

            <Skeleton variant="text" className="mt-2 h-3 w-11/12" />

            <div className="mt-2 flex flex-wrap items-center gap-1.5">
              <Skeleton className="h-6 w-14 rounded-full" />
              <Skeleton className="h-6 w-16 rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TodoKanbanBoard({
  todosByStatus,
  loading = false,
  onStatusChange,
  onReorder,
  onAction,
  onMove,
}) {
  if (loading) {
    return (
      <>
        <div className="hidden gap-4 md:grid md:grid-cols-4">
          {TODO_STATUS_COLUMNS.map((column) => (
            <TodoKanbanBoardSkeletonColumn key={column.id} column={column} />
          ))}
        </div>

        <div className="flex flex-col gap-3 md:hidden">
          {TODO_STATUS_COLUMNS.map((column) => (
            <TodoKanbanBoardSkeletonColumn key={column.id} column={column} />
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="hidden md:grid md:grid-cols-4 gap-4">
        {TODO_STATUS_COLUMNS.map(column => (
          <TodoKanbanColumn
            key={column.id}
            column={column}
            items={todosByStatus[column.id] || []}
            onAction={onAction}
            onMove={onMove}
            onDrop={onStatusChange}
            onReorder={onReorder}
          />
        ))}
      </div>

      <div className="md:hidden flex flex-col gap-3">
        {TODO_STATUS_COLUMNS.map(column => (
          <TodoKanbanColumn
            key={column.id}
            column={column}
            items={todosByStatus[column.id] || []}
            onAction={onAction}
            onMove={onMove}
            onDrop={onStatusChange}
            onReorder={onReorder}
          />
        ))}
      </div>
    </>
  );
}
